export default __webpack_public_path__ + "static/media/ColdEyes_img.b7ebeec8.jpg";